import { z } from "zod";
import { zodParseWithDetailedLog, ZodErrorContext } from "../utils/zodErrorLogger";

/**
 * @deprecated Use zodParseWithDetailedLog from utils/zodErrorLogger instead
 * This function is kept for backward compatibility
 */
export const zodParseWithLog = <T>(data: unknown, schema: z.ZodSchema<T>, operation: string): T => {
    const context: ZodErrorContext = {
        operation,
        data,
    };

    return zodParseWithDetailedLog(data, schema, context);
};

// Re-export new utilities for convenience
export {
    zodParseWithDetailedLog,
    zodSafeParse,
    zodParseArray,
    createZodApiWrapper,
    logZodSchema,
    formatZodError,
    type ZodErrorContext,
    type ZodErrorDetails,
} from "../utils/zodErrorLogger";
